module.exports = __webpack_public_path__ + "static/media/Architecture_01.e309870c.jpg";